// RichTextEditor.jsx
import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";

const RichTextEditor = ({
  value,
  onChange,
  placeholder,
  height,
  onFocus,
  onBlur,
}) => {
  const ref = useRef();

  useEffect(() => {
    if (ref.current && value !== ref.current.innerHTML) {
      ref.current.innerHTML = value;
    }
  }, [value]);

  return (
    <div
      ref={ref}
      contentEditable
      suppressContentEditableWarning
      onInput={(e) => onChange(e.currentTarget.innerHTML)}
      onFocus={onFocus}
      onBlur={onBlur}
      style={{
        minHeight: height || 200,
        padding: "12px",
        border: "1px solid #ccc",
        borderRadius: "6px",
        fontSize: "18px",
        lineHeight: "1.5",
        outline: "none",
        overflowY: "auto",
        background: "white",
      }}
    >
      {/* Placeholder support */}
      {(!value || value.trim() === "") && (
        <span style={{ opacity: 0.4 }}>{placeholder}</span>
      )}
    </div>
  );
};

RichTextEditor.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  placeholder: PropTypes.any,
  height: PropTypes.any,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

export default RichTextEditor;
